const config = require('./client_secrets.json');

const clientSecrets = {
  PDFTRON_WEBVIEWER_LICENSE_KEY: config.PDFTRON_WEBVIEWER_LICENSE_KEY,
  ANALYTICS_URL: config.ANALYTICS_URL,
  GTM_ID: config.GTM_ID || '',
  SWR_ERROR_TOAST_ENABLED: config.SWR_ERROR_TOAST_ENABLED === 'true',
  BROKER: config.BROKER,
  IDLE_MODAL_TIMEOUT_MINUTES: Number(config.IDLE_MODAL_TIMEOUT_MINUTES || 30), // 30 minutes,
  IDLE_MODAL_LOGOUT_MINUTES: Number(config.IDLE_MODAL_LOGOUT_MINUTES || 2), // 2 minutes,
  ENVIRONMENT_NAME: config.ENVIRONMENT_NAME,
  DATABASE_NAME: config.DATABASE_NAME || '',
  PUSHER_KEY: config.PUSHER_KEY,
  PRINT_BATCH_SIZE: config.PRINT_BATCH_SIZE
    ? Number(config.PRINT_BATCH_SIZE)
    : 200,
  BCC_ARCHIVAL_EMAIL_FORWARDING_ADDRESS:
    config.BCC_ARCHIVAL_EMAIL_FORWARDING_ADDRESS || '',
  PUSHER_CLUSTER: config.PUSHER_CLUSTER,
  FREE_FORM_FEATURE_FLAG: config.FREE_FORM_FEATURE_FLAG === 'true',
  PDF_IMPORT_FEATURE_FLAG: config.PDF_IMPORT_FEATURE_FLAG === 'true',
  TOP_BRANDING_URL: config.TOP_BRANDING_URL,
  BULK_REVISION_MAX_CERTS: config.BULK_REVISION_MAX_CERTS
    ? Number(config.BULK_REVISION_MAX_CERTS)
    : 5000,
  RENEWAL_MAX_CERTS: config.RENEWAL_MAX_CERTS
    ? Number(config.RENEWAL_MAX_CERTS)
    : 5000,
  INBOUND_UPLOAD_MAX_CERTS: config.INBOUND_UPLOAD_MAX_CERTS
    ? Number(config.INBOUND_UPLOAD_MAX_CERTS)
    : 5000,
  BULK_DOWNLOAD_MAX_CERTS: config.BULK_DOWNLOAD_MAX_CERTS
    ? Number(config.BULK_DOWNLOAD_MAX_CERTS)
    : 5000,
  QUICK_ISSUE_EMAIL: config.QUICK_ISSUE_EMAIL || '',
  ALLOWED_EXTERNAL_TESTING_EMAILS: config.ALLOWED_EXTERNAL_TESTING_EMAILS || '',
  USE_DIVISIONS: config.USE_DIVISIONS === 'true',
  DOWNLOAD_BATCH_SIZE: config.DOWNLOAD_BATCH_SIZE
    ? Number(config.DOWNLOAD_BATCH_SIZE)
    : 5000,
};

function verifyConfig(secrets) {
  // Check if all our expected key names are there
  Object.keys(secrets).forEach(key => {
    const value = secrets[key];
    if (value === null || value === undefined) {
      throw Error(`Client ${key} value is missing, exiting. 
      Try running "npm run load-secrets`);
    }
  });
}

verifyConfig(clientSecrets);

export const CLIENT_SECRETS = clientSecrets;
